import { useInView } from "framer-motion"
import { createContext, forwardRef, lazy, useLayoutEffect, useRef, useState } from "react"

import ToggleNighttime from "./ToggleNighttime"

import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"
import { useHeader } from "contexts/Header"

import camelCase from "utils/camelCase"

import Image from "components/media/ImageCLD"
import ShowVariations from "components/model/model-variations/Launcher"
import Price from "components/price/Price"
import WishlistButton from "components/wishlist-button/WishlistButton"

import { useEnv } from "contexts/Env"
import { useModel } from "../context"
import {
  DayFigure,
  H1,
  HGroup,
  ModelCover,
  NewModelWrapper,
  NightFigure,
  NighttimeWrapper,
  Options,
  Root,
  ShadowFigure,
  ShortSpecs,
  Textblock,
  Title,
} from "./style"

const Launcher = lazy(() => import("components/model/model-box/Launcher"))

// function scrollToTop() {
//   return new Promise(resolve => {
//     window.addEventListener("scroll", scrollHandler, false)
//     if (window.scrollY === 0) return resolve()
//     window.scrollTo({
//       top: 0,
//       behavior: "auto",
//     })

//     function scrollHandler(e) {
//       if (window.scrollY === 0) {
//         window.removeEventListener("scroll", scrollHandler, false)
//         resolve()
//       }
//     }
//   })
// }

export default function ModelMajesty({ localDictionary, ...props }) {
  const hash = process.browser ? window.location.hash.split("").slice(1).join("") : ""
  const ctx = createContext(null)

  return (
    // <WatchVariationsContextProvider
    //   Ctx={ctx}
    //   entry={props.rmc}
    //   active={props.rmc}
    //   route={hash}
    //   family={props.familyNode.code}
    //   variations={props.variations}
    //   mode='cover'
    // >
    <ModelMajestyContents localDictionary={localDictionary} {...props} ctx={ctx} />
    // </WatchVariationsContextProvider>
  )
}

function ModelMajestyContents({ localDictionary, has360, ...props }) {
  const console = useConsole()
  const env = useEnv()

  const {
    rmc,
    name,
    //
    case: {
      labels: { title: short_specs },
    },
    editorial_mapping: {
      cover,
      majesty: { watch_day_image_landscape_cl, watch_night_image_landscape_cl },
    },
  } = props

  const nightImage = !!watch_night_image_landscape_cl?.length
    ? [
      {
        public_id: `catalogue/${env.catalogYear}/luminescence/${rmc}`,
        width: 800,
        height: 1180,
        policy: "t_v7-main-configurator",
      },
    ]
    : null

  const handleRef = useRef()

  function onCoverClick(e) {
    handleRef.current.currentIndex.set(0)
    has360 ? handleRef.current.open() : handleRef.current.openLBonly()
  }

  return (
    <Root>
      {/* <ModelVariations ctx={props.ctx} nightImage={nightImage} cover={cover} name={name} short_specs={short_specs} onCoverClick={onCoverClick}> */}
      <ModelMajestyCover localDictionary={localDictionary} has360={has360} {...props} ref={handleRef} onCoverClick={onCoverClick} />
      {/* </ModelVariations> */}
    </Root>
  )
}

const ModelMajestyCover = forwardRef(({ localDictionary, allowedPriceOnSSR, ctx, has360, onCoverClick, ...props }, handler) => {
  // const console = useConsole()

  // const { isVariationOpen } = useModel()
  const header = useHeader()

  // const { route, fromui, glow } = useWatchVariations(ctx)

  const rfmain = useRef()

  const [isNighttime, setIsNighttime] = useState(false)
  // const [isGlow, setIsGlow] = useState(false)
  const coverInView = useInView(rfmain)
  const env = useEnv()

  // Dictionary
  const translation = new Proxy(
    (localDictionary || []).reduce((acc, { translation: { key, value } }) => {
      acc[camelCase(key)] = (...variables) => {
        let translatedAs = value
        for (const [i, variable] of variables.entries()) translatedAs = translatedAs.replaceAll(`{{${i + 1}}}`, variable)
        return translatedAs
      }

      return acc
    }, {}),
    {
      get: (t, k) => {
        if (t.hasOwnProperty(k)) return t[k]
        else return () => `%MISSING(${k})%`
      },
    }
  )

  const {
    rmc,
    name,
    newmodelselection,
    bracelet_id,
    case_id,
    alt,
    case: {
      labels: { title: short_specs },
    },
    editorial_mapping: {
      majesty: { watch_day_image_landscape_cl, watch_night_image_landscape_cl },
    },
    variationsCtaImage_cl: variationsCtaImage,
  } = props

  const dictionary = useDictionary()

  //  const variationsCtaImageFAKE = '[{"src":"catalogue/2023-06/raw-dial-constant-size-with-shadow/m126234-0015","policy":"t_v7-model-variation","path":"catalogue:2023-06:raw-dial-constant-size-with-shadow:m126234-0045"}]'

  let variationsCtaImageJson = null
  try {
    variationsCtaImageJson = variationsCtaImage ? JSON.parse(variationsCtaImage) : null
  } catch (e) { }

  const variationsCtaImageProps = variationsCtaImageJson?.length ? variationsCtaImageJson[0] : null
  const variationsCtaImagePicture = variationsCtaImageProps
    ? {
      public_id: variationsCtaImageProps.src,
      version: 1,
      path: variationsCtaImageProps.path,
      policy: variationsCtaImageProps.policy,
      width: 120,
      height: 120,
    }
    : {}

  const lbSrc = [
    {
      public_id: `catalogue/${env.catalogYear}/upright-c/${rmc}`,
      version: 1,
      policy: "t_v7",
      width: 330,
      height: 492,
    },
  ]

  const dayImage = [
    {
      public_id: `catalogue/${env.catalogYear}/upright-c/${rmc}`,
      version: 1,
      policy: "t_v7-majesty",
      width: 800,
      height: 1180,
    },
  ]

  const shadowImage = [
    {
      public_id: `catalogue/${env.catalogYear}/upright-c-shadow/${rmc}`,
      version: 1,
      policy: "t_v7-majesty-shadow",
      width: 800,
      height: 1380,
    },
  ]

  const nightImage = !!watch_night_image_landscape_cl?.length
    ? [
      {
        public_id: `catalogue/${env.catalogYear}/luminescence/${rmc}`,
        width: 800,
        height: 1180,
        policy: "t_v7-majesty",
      },
    ]
    : null

  // function onVariationsClick(e) {
  //   rfmain.current?.classList.add("wv_hide")
  //   scrollToTop()
  //   fromui.set(true)
  //   route.set(LAUNCH_ROUTE)

  //   isVariationOpen.set(true)
  // }

  // function onRoute(v) {
  //   rfmain.current?.classList[!!v ? "add" : "remove"]("wv_hide")
  // }

  // useLayoutEffect(() => mvSubscribe("ModelMajestyContents route", route, onRoute), [])

  useLayoutEffect(() => {
    if (!coverInView && isNighttime) {
      setIsNighttime(!isNighttime)
    }
  }, [coverInView])

  // useLayoutEffect(() => glow.set(isNighttime), [isNighttime]) // TODO

  return (
    <ModelCover ref={rfmain} day={!isNighttime} className={isNighttime ? "dark-theme" : "light-theme"} headerHeight={header.cssVars.height}>
      <NewModelWrapper mobile={true}>
        <WishlistButton rmc={rmc} family={props.familyNode?.code} modelName={name} newmodelselection={newmodelselection} withLabel />
      </NewModelWrapper>
      <Textblock>
        <NewModelWrapper mobile={false}>
          <WishlistButton rmc={rmc} family={props.familyNode?.code} modelName={name} newmodelselection={newmodelselection} withLabel />
        </NewModelWrapper>
        <HGroup>
          <H1>
            <Title id='mj-watchName'>{name}</Title>
            <ShortSpecs dangerouslySetInnerHTML={{ __html: short_specs }} />
            <ShortSpecs>
              {translation.reference()} {props?.reference_code}
            </ShortSpecs>
          </H1>
        </HGroup>
        <Price rmc={rmc} no_observer={true} ariaDescribedBy='mj-watchName' result={allowedPriceOnSSR} />
      </Textblock>

      <ShadowFigure day={!isNighttime}>
        <Image sources={shadowImage} sizes='(min-width: 48rem) 42vw, 85vw' loading='eager' />
      </ShadowFigure>

      <DayFigure day={!isNighttime} onClick={onCoverClick}>
        <Image alt={alt} sources={dayImage} sizes='(min-width: 48rem) 42vw, 85vw' loading='eager' />
      </DayFigure>

      <NightFigure day={!isNighttime}>
        <Image alt={alt} sources={nightImage} sizes='(min-width: 48rem) 42vw, 85vw' loading='lazy' decoding='async' />
      </NightFigure>

      {watch_night_image_landscape_cl || has360 ? (
        <Options className={[watch_night_image_landscape_cl && has360 && "full"].filter(Boolean).join(" ")}>
          {watch_night_image_landscape_cl && (
            <NighttimeWrapper>
              <ToggleNighttime
                isSelected={isNighttime}
                onChange={setIsNighttime}
                ariaLabel={isNighttime ? dictionary.activateDaytime() : dictionary.activateNighttime()}
              />
            </NighttimeWrapper>
          )}
          <Launcher
            ref={handler}
            separator={!!watch_night_image_landscape_cl}
            rmc={rmc}
            braceletId={bracelet_id}
            caseId={case_id}
            start={props?.ballerina?.start}
            has360={has360}
            lbSrc={lbSrc}
          />
        </Options>
      ) : (
        <Launcher
          ref={handler}
          separator={!!watch_night_image_landscape_cl}
          rmc={rmc}
          braceletId={bracelet_id}
          caseId={case_id}
          start={props?.ballerina?.start}
          has360={has360}
          lbSrc={lbSrc}
        />
      )}

      {!!props.variations?.length && (
        <ShowVariations style={{ opacity: isNighttime ? 0 : 1 }} disabled={isNighttime} rmc={rmc} family={props.familyNode?.code} variations={props.variations}>
          <Image loading='eager' alt='' sizes='20vw' sources={[variationsCtaImagePicture]} aria-hidden='true' />
          <span>{dictionary.viewVariations()}</span>
        </ShowVariations>
      )}
    </ModelCover>
  )
})
